(() => {
  const tabs = document.querySelectorAll('.sg-manual-suits__fit-selection-btn');

  const splide = new Splide('.sg-manual-suits__table-wrapper', {
    label: 'Suit size tables',
    type: 'fade',
    rewind: true,
    arrows: false,
    pagination: false,
    drag: false,
    wheel: false,
    keyboard: false,
  });

  const setActiveTab = (newIdx) => {
    for (let i = 0; i < tabs.length; i++) {
      const isActive = i === newIdx;
      tabs[i].classList.toggle('sg-manual-suits__fit-selection-btn--active', isActive);
      tabs[i].setAttribute('aria-selected', String(isActive));
    }
  };

  splide.on('moved', (newIdx) => setActiveTab(newIdx));

  for (let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', () => splide.go(i));
  }

  splide.mount();
})();
